/** A ledger to keep track of z-index usage */
/** Highest to lowest */
export default {
  INPUT: 1, // Checkbox, RadioButton
  BUTTON: 2,
  SIDEDRAWER_CONTENT: 2, // Side Drawer item content
  TAB_CLOSE_BUTTON: 3, // Close Button inside of Tab
  BADGE: 4, // Badge in Side Drawer Button
  APP_BANNER: 1, // Needed to be above MultiSelectToolbar animation
  APP_HEADER: 1, // Needed to be above AppBody
  APP_HEADER_TOOLBAR: 0, // Needed to be below AppBanner
  APP_TOOLBAR: 1, // Needed to be above AppBody
  APP_BODY: 0, // Needed to be below App Banner
  COACHMARKS: 29,
  BANNER_POPUP: 50, // AppBanner Popups
  SIDE_DRAWER: 10000, // Side Drawer
  OVERLAY_PANEL: 10000, // Side Drawer
  DIALOG: 11000,
  MENU: 12000, // SelectItem, Calendar
  FLOATING_PANEL: 13000,
  TOOLTIP: 2147483647,
  CARD: {
    dragging: 3,
    placeholder: 2,
    expanded: 4,
    modal: 11000 // Same as Dialog
  },
  EXPANSION_PANEL: {
    header: 1,
    body: 0
  }
};
